<template>
    <button @click="label = 'Működik'"
            class="p-4 rounded-sm bg-blue-400 text-white" v-html="label"></button>
</template>

<script>
    export default {
        data: function () {
            return {
                label: 'Kattins Vue.js teszthez'
            }
        },
        mounted() {
        },
        methods: {},
        computed: {},
        watch: {}

    }
</script>
